import type { Maybe } from "~/types/ts-utils"

export const imageOrFallback = (src: Maybe<string>): string => {
  return (
    src ||
    "https://images.prismic.io/interruptor/4047f8cd-93e1-4a7f-a675-231db1112f49_crop_podcast_1440x1440.jpg?auto=compress,format"
  )
}
